import { type InternalAxiosRequestConfig } from "axios";

import { faro } from "@grafana/faro-web-sdk";
import { getBaseURL } from "@vega-core/utils/global";
import { isTruthy } from "@vega-core/utils/isTruthy";

const EIGHT_KB = 8192;

export const calculateUrlLength = (
  config: InternalAxiosRequestConfig,
): number => {
  const baseURL = config.baseURL ?? getBaseURL();
  const url = config.url ?? "";
  const params = config.params;

  let fullUrl = baseURL + url;

  if (isTruthy(params)) {
    const searchParams = new URLSearchParams();

    const serializeParam = (key: string, value: unknown): void => {
      if (Array.isArray(value)) {
        value.forEach((item) => serializeParam(key, item));
      } else if (value !== null && value !== undefined) {
        searchParams.append(key, String(value));
      }
    };

    Object.entries(params).forEach(([key, value]) =>
      serializeParam(key, value),
    );

    const queryString = searchParams.toString();

    if (queryString) {
      fullUrl += `?${queryString}`;
    }
  }

  const urlLength = fullUrl.length;

  if (urlLength > EIGHT_KB && isTruthy(faro)) {
    faro.api.pushError(
      new Error(`GET request URL length exceeds 8KB: ${urlLength} bytes`),
      {
        type: "url_length_exceeded",
        context: {
          urlLength: String(urlLength),
          baseURL,
          url,
          method: config.method ?? "GET",
        },
      },
    );
  }

  return urlLength;
};
